import type { PaginatedResponse } from '@repo/types/pagination';
import type { ParentChildAssignment } from '@repo/types/parent';
import type { UserPublic } from '@repo/types/users';

import type { GetChildListParams } from './parentService';
import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * A page of assignments per linked child, aggregated.
 *
 * `paramsFor` derives each child's query — children paginate independently, so
 * `page` typically differs per child while the filters are shared.
 */
export function useGetChildrenAssignments(
  children: UserPublic[],
  paramsFor?: (child: UserPublic) => GetChildListParams,
  enabled = true
): ChildrenResourceResult<PaginatedResponse<ParentChildAssignment>> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_ASSIGNMENTS, child.id, paramsFor?.(child)],
    (child) => ParentService.getChildAssignments(child.id, paramsFor?.(child)).then((response) => response.data),
    enabled
  );
}
